// extracted by mini-css-extract-plugin
export default {"container":"PasswordForm_container__k16BL","bottom":"PasswordForm_bottom__SwY9f"};